import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material';

const IFrame = styled('iframe')({
	width: '100%',
	height: '100%',
});

export default function YoutubePlayer({ sx, youtubeId }) {
	return (
		<>
			{!!youtubeId && (
				<IFrame
					sx={sx}
					title={youtubeId}
					frameBorder="0"
					allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
					src={`https://www.youtube.com/embed/${youtubeId}`}
					allowFullScreen
				/>
			)}
		</>
	);
}

YoutubePlayer.propTypes = {
	youtubeId: PropTypes.string,
};
